export const BASE_URL = process.env.REACT_APP_BASE_URL;

let globalVar = {
  url: BASE_URL,
  Token: localStorage.getItem("token") ?? "",
};

export const getGlobalVar = () => globalVar;
export const setGlobalVar = (value) => {
  globalVar.Token = value;
};
